import type { CalendarEvent } from "../models/calendar.model"

export const EVENT_STATUS_PALETTE: Record<CalendarEvent["status"], {
  solid: string
  light: string
  text: string
  darkText: string
  darkLight: string
}> = {
  ongoing: {
    solid: "#10B981",
    light: "rgba(16, 185, 129, 0.18)",
    text: "#065F46",
    darkText: "#34D399",
    darkLight: "rgba(16, 185, 129, 0.25)",
  },
  upcoming: {
    solid: "#F59E0B",
    light: "rgba(245, 158, 11, 0.16)",
    text: "#92400E",
    darkText: "#FBBF24",
    darkLight: "rgba(245, 158, 11, 0.22)",
  },
  completed: {
    solid: "#94A3B8",
    light: "rgba(148, 163, 184, 0.2)",
    text: "#475569",
    darkText: "#CBD5E1",
    darkLight: "rgba(148, 163, 184, 0.3)",
  },
}

export function getEventPalette(event: CalendarEvent) {
  return EVENT_STATUS_PALETTE[event.status]
}
